import { useBILogger } from '@wix/fe-essentials/react';
import { useCallback, useMemo } from 'react';
import { getEditorSubType } from '../../../utils';
import { PluginActionContext } from '@wix/editor-platform-host-integration-apis';

const EVENT_ID = {
  PLUGIN_REMOVE_CLICK: 106,
  PLUGIN_HOVER: 208,
};

export type UninstallPluginEventPayload = {
  plugin_id: string;
  host_app_id: string;
  editor_type?: string;
  editorType?: string;
} & { origin: PluginActionContext['biOrigin'] };

export type HoverPluginEventPayload = {
  origin: 'plugin_market_card' | 'plugin_manage_card';
  action_context: string;
  editor_type?: string;
  editorType?: string;
};

export const usePluginsBi = () => {
  const logger = useBILogger();
  const editorType = getEditorSubType();

  const defaultPluginEvents = useMemo(
    () => ({
      target_type: 'widget_plugins',
    }),
    [],
  );

  const addEditorTypeToPayload = (
    payload: UninstallPluginEventPayload | HoverPluginEventPayload,
    evid: number,
  ) => {
    if (evid === EVENT_ID.PLUGIN_REMOVE_CLICK) {
      payload.editorType = editorType;
    }
    if (evid === EVENT_ID.PLUGIN_HOVER) {
      payload.editor_type = editorType;
    }
  };

  const pluginRemoveClick = useCallback(
    (payload: UninstallPluginEventPayload) => {
      log(payload, EVENT_ID.PLUGIN_REMOVE_CLICK, 'click');
    },
    [defaultPluginEvents, logger, editorType],
  );

  const pluginHover = (payload: HoverPluginEventPayload) => {
    log(payload, EVENT_ID.PLUGIN_HOVER);
  };

  const log = (payload: any, evid: number, method?: string) => {
    addEditorTypeToPayload(payload, evid);
    logger.log({
      ...payload,
      ...defaultPluginEvents,
      evid,
      method,
    });
  };

  return {
    pluginRemoveClick,
    pluginHover,
  };
};
